import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../lib/utils';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  interactive?: boolean;
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className,
  children,
  interactive = false,
  ...props
}, ref) => {
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} whileHover={interactive ? {
    y: -4,
    boxShadow: '0 10px 30px -10px rgba(0,0,0,0.1)'
  } : undefined} className={cn('bg-white rounded-xl border border-slate-200 p-6', interactive && 'cursor-pointer transition-shadow duration-300', className)} {...props} data-id="element-761">
        {children}
      </motion.div>;
});
Card.displayName = 'Card';